import React, { useRef, useState } from "react";
import "./news.scss";
import Button from "../../buttons/Button";
import PopPage from "../../PopPage";
import {motion} from 'framer-motion'
const News = () => {
  const [displayCount, setDisplayCount] = useState(6); // New state variable

  const [singlenews, setSinglenews] = useState(false);

  const data = [
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876258/allec-gomes-ftEtxZjEJX8-unsplash_a6hgwk.jpg",
      title: "Developers watch out for these burnout symptoms",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876258/allec-gomes-ftEtxZjEJX8-unsplash_a6hgwk.jpg",
      title: "Developers watch out for these burnout symptoms",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876258/allec-gomes-ftEtxZjEJX8-unsplash_a6hgwk.jpg",
      title: "Developers watch out for these burnout symptoms",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876375/mae-mu-vbAEHCrvXZ0-unsplash_1_ilwkmm.jpg",
      title: "Developers watch out for these burnout symptoms",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876375/mae-mu-vbAEHCrvXZ0-unsplash_1_ilwkmm.jpg",
      title: "Developers watch out for these burnout symptoms",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876375/mae-mu-vbAEHCrvXZ0-unsplash_1_ilwkmm.jpg",
      title: "Developers watch out for these burnout symptoms",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876254/giorgio-trovato-cw1MAVs4wV8-unsplash_fljja1.jpg",
      title: "Developers watch out for these burnout symptoms",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876254/giorgio-trovato-cw1MAVs4wV8-unsplash_fljja1.jpg",
      title: "Developers watch out for these burnout symptoms",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876254/giorgio-trovato-cw1MAVs4wV8-unsplash_fljja1.jpg",
      title: "Developers watch out for these burnout symptoms",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876252/mae-mu-U1iYwZ8Dx7k-unsplash_1_qgylim.jpg",
      title: "Developers watch out for these burnout symptoms",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876252/mae-mu-U1iYwZ8Dx7k-unsplash_1_qgylim.jpg",
      title: "Developers watch out for these burnout symptoms",
    },
    {
      img: "https://res.cloudinary.com/raiusl/image/upload/v1687876252/mae-mu-U1iYwZ8Dx7k-unsplash_1_qgylim.jpg",
      title: "Developers watch out for these burnout symptoms",
    },
  ];
  const handleLoadMore = () => {
    setDisplayCount(displayCount + 3);
  };

  function NewsCard({img,title}) {
    return (
      <motion.div 
           initial={{opacity:0}}
        animate={{opacity:1}} 
        transition={{type:"tween", duration:.5}}
       onClick={() => setSinglenews(true)} className="news-card">
        <div className="img">
          <img
            src={img}
            alt=""
          />
        </div>
        <div className="text">
          <span>BY ALEX WATSON || 20 MAY 2020</span>
          <h3>{title}</h3>
        </div>
      </motion.div>
    );
  }
  return (
    <div className="news">
      <h2>Latest News</h2>
      <div className="grid">
        {data.slice(0, displayCount).map((item, index) => (
          <NewsCard key={index} img={item.img} title={item.title} />
        ))}
      </div>
      <div className="load-more">
        {data.length > displayCount && ( // Display "Load More" button conditionally
          <Button onClick={handleLoadMore} name={"Load More"} />
        )}
      </div>
      {singlenews ? (
        <SingoleNewsSection
          singlenews={singlenews}
          setSinglenews={setSinglenews}
        />
      ) : null}
    </div>
  );
};

export default News;

function SingoleNewsSection({ singlenews, setSinglenews }) {
  return (
    <PopPage>
      <div className="single-news-wrapper">
        <span className="close-box" onClick={() => setSinglenews(false)}>
          <i class="fa-solid fa-xmark"></i>
        </span>
        <div className="single-news">
          <div className="top-box">
            <div className="img">
              <img
                src="https://res.cloudinary.com/raiusl/image/upload/v1687877699/thought-catalog-9aOswReDKPo-unsplash_v0o9o8.jpg"
                alt=""
              />
            </div>
            <span>BY BROOK KENNEDY 07 APRIL 2020</span>
            <h2>How to be appreciated for your hard work as a developer</h2>
          </div>
          <p>
            As Vintage decided to have a closer look into fast-paced New York
            web design realm in person, we get to acquaint with most diverse and
            exceptionally captivating personalities. As Vintage decided to have
            a closer look into fast-paced New York web design realm in person,
            we get to acquaint with most diverse and exceptionally captivating
            personalities. As Vintage decided to have a closer look into
            fast-paced New York web design realm in person, we get to acquaint
            with most diverse and exceptionally captivating personalities.
          </p>

          <div className="box">
            <p>
              As Vintage decided to have a closer look into fast-paced New York
              web design realm in person, we get to acquaint with most diverse
              and exceptionally captivating personalities. As Vintage decided to
              have a closer look into fast-paced New York web design realm in
              person, we
            </p>
          </div>
          <p>
            As Vintage decided to have a closer look into fast-paced New York
            web design realm in person, we get to acquaint with most diverse and
            exceptionally captivating personalities. As Vintage decided to have
            a closer look into fast-paced New York web design realm in person,
            we get to acquaint with most diverse and exceptionally captivating
            personalities. As Vintage decided to have a closer look into
            fast-paced New York web design realm in person, we get to acquaint
            with most diverse and exceptionally captivating personalities.
          </p>

          <div className="shear">
            <h4>Shear: </h4>
            <div className="icon-box">
              <span>
                <a href="#">
                  <i class="fa-brands fa-facebook-f"></i>
                </a>
              </span>
              <span>
                <a href="#">
                  <i class="fa-brands fa-instagram"></i>
                </a>
              </span>
              <span>
                <a href="#">
                  <i class="fa-brands fa-twitter"></i>
                </a>
              </span>
              <span>
                <a href="#">
                  <i class="fa-brands fa-linkedin"></i>
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </PopPage>
  );
}
